import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { toAbsoluteUrl } from '../../../helpers';
import { HeaderUserMenu } from '../../../partials';
import { useLanguage } from '../../../helpers/utils/context';
import styles from './Navbar.module.css';

const itemClass = 'ms-1 ms-md-4';
const userAvatarClass = 'symbol-35px';

const Navbar = () => {
  const { setLanguage } = useLanguage();
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem('language') || 'valueEnglish'
  );

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'valueEnglish' ? 'valueFrench' : 'valueEnglish';
    localStorage.setItem('language', newLanguage);
    setLanguage(newLanguage);
    setCurrentLanguage(newLanguage);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      setCurrentLanguage(storedLanguage);
    }
  }, []);

  return (
    <div className='app-navbar flex-shrink-0 '>
      <div className='flex-col items-center justify-center'>
        <button
          style={{
            width: '100px',
            height: '40px',
            borderRadius: '20px'
          }}
          className={styles.buttonLang}
          onClick={toggleLanguage}
        >
          {currentLanguage === 'valueEnglish' ? 'FRA' : 'ENG'}
        </button>
      </div>
      <div className={clsx('app-navbar-item', itemClass)}></div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img
            src={toAbsoluteUrl('/media/logos/face-logo.svg')}
            alt='face-logo'
            style={{ backgroundColor: 'black' }}
          />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  );
};

export { Navbar };
